document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelectorAll(".lr-colour-dot") !== undefined) {
        const megaMenuLink = document.querySelectorAll(".lr-colour-dot");

        for (let i = 0; i < megaMenuLink.length; i++) {
            const element = megaMenuLink[i];
            const extractedColour = element.nextElementSibling.innerHTML
                .trim()
                .split(" ")[0];

            switch (extractedColour) {
                case "Burgundy":
                    element.style.backgroundColor = "maroon";
                    break;
                case "Multi-Coloured":
                    element.style.backgroundImage =
                        "linear-gradient(to right, red,orange,yellow,green,blue,indigo,violet)";
                    break;
                case "Metallic":
                    element.style.backgroundColor = "#D9D6CF";
                    break;
                case "Terracotta":
                    element.style.backgroundColor = "#E2725B";
                    break;
                case "Cream":
                    element.style.backgroundColor = "#FFFDD0";
                    break;
                case "White":
                    element.style.backgroundColor = "white";
                    element.style.border = "1px solid black";
                    break;
                case "Taupe":
                    element.style.backgroundColor = "#483C32";
                    break;
                case "Copper":
                    element.style.backgroundColor = "#b5422b";
                    break;
                default:
                    element.style.backgroundColor = extractedColour || "black";
                    break;
            }
        }
    }
})